import React, {
  useState,
  useRef,
} from 'react';
import './MaterialVisibilityChange.css';
import { useStores } from '../../../hooks/use-stores';
import Portal from '../../Portal/Portal.tsx';

const MaterialVisibilityChange = (props) => {
  const [active, setActive] = useState(false);
  const buttonRef = useRef(null);
  const { materialStore } = useStores();

  return (!!props.materials && !!props.materials.length && (
    <div className="material-visibility-change">
      <a ref={buttonRef}
        className="btn-material-visibility-toggle"
        title="Change Material"
        onClick={e => {
          e.preventDefault();
          setActive(!active);
        }}>
        <i className="fa fa-arrow-down"/>
      </a>
      <Portal
        isOpen={active}
        anchorRef={buttonRef}
        onClickOutside={() => setActive(false)}
      >
        <div className="materials-visibility-wrapper">
          <h3>Change Material:</h3>
          <ul>
            {props.materials.map(m => (
              <li key={m.code}>
                <a onClick={e => {
                  e.preventDefault();
                  props.onMaterialClick(m);
                  setActive(false);
                }}>
                  {materialStore.getMaterialName(m)}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </Portal>
    </div>
  )
  );
};

export default MaterialVisibilityChange;
